import axios from "axios";
import React, { useState, useEffect } from 'react'
import techNewsConfig from "../Config/techNewsConfig";
import Main from '../Main'
import BackToService from './BackToService';

function News() {

    var today = new Date();
    const [newsDetails, setNewsDetails] = useState([]);
    const [country, setCountry] = useState("in");
    const [category, setCategory] = useState("technology")

    const fetchNewsDetails = async () => {
        const { data } = await axios.get(`${techNewsConfig}&country=${country}&category=${category}`);
        var articles = data.articles;
        setNewsDetails(articles);
    }

    useEffect(() => {
        fetchNewsDetails();
    }, [])

    return (
        <>
            <Main active="service">
                <div className="main">
                    <section>
                        <div className="container section-title">
                            <h2>Tech News <BackToService /></h2>
                            <div className="row">
                                {
                                    newsDetails.map((data) => {
                                        return (
                                            <div className="col-md-4" style={{ "marginTop": "15px" }}>
                                                <div className="card" style={{ "height": "500px" }}>
                                                    <img className="card-img-top" src={data.urlToImage} style={{ "height": "180px" }} alt="Card image cap" />
                                                    <div className="card-body" style={{ "position": "relative" }}>
                                                        <label>Date : {today.getDate() + "/" + (today.getMonth() + 1) + "/" + today.getFullYear()}</label>
                                                        <label className="news-label" title={data.author}>Author : {data.author}</label>
                                                        <h5 className="card-title">{data.title}</h5>
                                                        <p className="card-text">{data.description.length > 130 ? data.description.substr(0, 125) + '...' : data.description}</p>
                                                        <div className="footer" style={{ "textAlign": "center", "width": "100%", "position": "absolute", "bottom": "15px" }}><a href={data.url} className="btn btn-primary" target="_blank"><i className="bx bx-search" style={{ "marginRight": "10px" }}></i>More</a></div>
                                                    </div>
                                                </div>

                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </section>
                </div>
            </Main>
        </>
    )
}

export default News
